import { getCookie } from '@rategravity/frontend/modules/hubspot';
import { localStorage, sessionStorage } from '@rategravity/frontend/modules/storage';
import fetch from 'node-fetch';
import { handleSentryError } from './handle-error';

const RG_AUTH_TOKEN = 'RG_AUTH_TOKEN';
const anonTokenPrefix = 'anon|';

export const isAnonToken = (token) => token.startsWith(anonTokenPrefix);

export const getAuthToken = () =>
  localStorage.getItem(RG_AUTH_TOKEN) || sessionStorage.getItem(RG_AUTH_TOKEN);

export const clearAuthToken = () => {
  sessionStorage.removeItem(RG_AUTH_TOKEN);
  localStorage.removeItem(RG_AUTH_TOKEN);
};
export const setAuthToken = (token) => localStorage.setItem(RG_AUTH_TOKEN, token);

export const sessionifyAuthToken = () => {
  const token = getAuthToken();
  sessionStorage.setItem(RG_AUTH_TOKEN, token);
  localStorage.removeItem(RG_AUTH_TOKEN);
};

/**
 * Attempts to initialize a session with the backend.
 *   Rendering will be deferred until this promise resolves.
 *
 * Falls back to a locally generated token if fails.
 *
 * Returns the session token created.
 */
export const initializeSession = async () => {
  const existingToken = getAuthToken();
  try {
    const result = await fetch('/api/questionnaire/prepare', {
      headers: { ['x-rg-auth']: existingToken, 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        hubspotToken: getCookie()
      })
    });
    const resultBody = await result.json();
    return resultBody.userId;
  } catch (error) {
    // Report the error to sentry
    handleSentryError(error);
    // Generate your own Auth Token
    const randos = (window.crypto || window.msCrypto).getRandomValues(new Uint32Array(4));
    return randos.reduce((l, r) => l + r.toString(32), anonTokenPrefix);
  }
};



// WEBPACK FOOTER //
// ./src/modules/authenticate.js